/* eslint-disable */
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

/*------ import url and method ------*/
import * as url from "helper/UrlHelper";
import { deleteData, getData, postData, putData } from "utils/Gateway";

const NoteSection = ({
  noteAccessUserList = [],
  moduleName = "",
  leadId = null,
  contactId = null,
  invoiceId = null,
  invoiceDocId = null,
  taskId = null,
  setShowAlert = () => {},
  setAlertMessage = () => {},
  setMessageType = () => {},
}) => {
  /* ------------- Language translation imports starts here ------------- */
  const { t } = useTranslation();

  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const params = useParams();

  const [noteTitle, setNoteTitle] = useState("");
  const [noteDetails, setNoteDetails] = useState("");
  const [isPrivate, setIsPrivate] = useState(false);
  const [isSendNotification, setIsSendNotification] = useState(false);

  const [noteList, setNoteList] = useState([]);
  const [noteIdForUpdate, setNoteIdForUpdate] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  // Form visibility toggle
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [hasCheckedInitial, setHasCheckedInitial] = useState(false);
  const [isFetchingNotes, setIsFetchingNotes] = useState(true);

  // Accordion expand/collapse per note
  const [expandedNotes, setExpandedNotes] = useState({});

  // Transcript toggle per note
  const [showTranscript, setShowTranscript] = useState({});

  // Speech-to-text states
  const [showVoiceOffcanvas, setShowVoiceOffcanvas] = useState(false);
  const [isRecording, setIsRecording] = useState(false);
  const [isPaused, setIsPaused] = useState(false);
  const [transcribedText, setTranscribedText] = useState("");
  const [recognition, setRecognition] = useState(null);
  const [voiceLanguage, setVoiceLanguage] = useState("en-US");

  // validation of note
  const [validation, setValidation] = useState({
    titleWarning: false,
  });

  // Utility: format unix ms timestamp to HH:MM:SS
  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "";
    try {
      const numericTimestamp =
        typeof timestamp === "string" ? parseInt(timestamp) : timestamp;
      if (
        isNaN(numericTimestamp) ||
        numericTimestamp < 0 ||
        numericTimestamp > 4102444800000
      ) {
        return "Invalid time";
      }
      const date = new Date(numericTimestamp);
      if (isNaN(date.getTime())) return "Invalid time";
      return date.toLocaleTimeString("en-US", {
        hour12: false,
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
      });
    } catch (error) {
      return "Invalid time";
    }
  };

  // Utility: format duration ms to H:MM:SS
  const formatDuration = (durationMs) => {
    if (!durationMs || durationMs <= 0) return "0:00:00";
    try {
      const numericDuration =
        typeof durationMs === "string" ? parseInt(durationMs) : durationMs;
      if (isNaN(numericDuration) || numericDuration < 0) return "0:00:00";
      const totalSeconds = Math.floor(numericDuration / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;
      return `${hours}:${minutes.toString().padStart(2, "0")}:${seconds
        .toString()
        .padStart(2, "0")}`;
    } catch (error) {
      return "0:00:00";
    }
  };

  // function for validation
  const validationHandler = () => {
    let isValid = true;

    if (noteTitle === "") {
      setValidation((prevState) => ({ ...prevState, titleWarning: true }));
      isValid = false;
    }

    return isValid;
  };

  //function for get notes
  const getAllNotes = async () => {
    try {
      setIsFetchingNotes(true);

      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_NOTE +
        `?filternotetype=1`;

      if (leadId) {
        requestUrl += `&leadid=${leadId}`;
      }

      if (contactId) {
        requestUrl += `&contactid=${contactId}`;
      }

      if (invoiceId) {
        requestUrl += `&invoiceid=${invoiceId}`;
      }

      if (invoiceDocId) {
        requestUrl += `&invoicedocid=${invoiceDocId}`;
      }

      if (taskId) {
        requestUrl += `&taskid=${taskId}`;
      }

      const response = await getData(requestUrl);

      console.log("note response", response);

      if (response.status) {
        setNoteList(response.data);
      }
    } catch (error) {
      console.log(error.message);
    } finally {
      setIsFetchingNotes(false);
    }
  };

  //function for update note
  const updateNoteStatus = (note) => {
    setNoteIdForUpdate(note._id);
    setNoteTitle(note.title);
    setNoteDetails(note.details);
    setIsPrivate(note.isprivate);
    if (!isFormVisible) {
      setIsFormVisible(true);
    }
  };

  //function for save note
  const saveNoteHandler = async () => {
    console.log("noteAccessUserList", noteAccessUserList);
    if (validationHandler()) {
      try {
        setIsLoading(true);

        let noteData = {
          notetype: "1",
          title: noteTitle,
          details: noteDetails,
          isprivate: isPrivate,
          sendnotification: isSendNotification,
        };

        if (leadId) {
          noteData.leadid = leadId;
        }

        if (contactId) {
          noteData.contactid = contactId;
        }

        if (invoiceId) {
          noteData.invoiceid = invoiceId;
        }

        if (invoiceDocId) {
          noteData.invoicedocid = invoiceDocId;
        }

        if (taskId) {
          noteData.taskid = taskId;
        }

        if (isPrivate) {
          noteData.noteaccessusers = [];
        } else {
          noteData.noteaccessusers = noteAccessUserList;
        }

        let requestUrl =
          url.API_BASE_URL + url.API_ADD_NEW_NOTE;

        const response = await postData(requestUrl, noteData);

        setIsLoading(false);

        console.log(response);

        if (response.status) {
          setMessageType("success");
          resetHandler();
          getAllNotes();
        } else {
          setMessageType("error");
        }

        setAlertMessage(response.message);
      } catch (error) {
        setAlertMessage(error.message);
        setMessageType("error");
      }
    }

    setShowAlert(true);
  };

  //function for reset note form
  const resetHandler = () => {
    setNoteTitle("");
    setNoteDetails("");
    setIsPrivate(false);
    setIsSendNotification(false);
    setNoteIdForUpdate(null);
    setValidation({
      titleWarning: false,
      detailsWarning: false,
    });
    setShowTranscript({});
  };

  //function for update note
  const updateNoteHandler = async () => {
    try {
      setIsLoading(true);

      let noteData = {
        title: noteTitle,
        details: noteDetails,
        isprivate: isPrivate,
      };

      let requestUrl =
        url.API_BASE_URL +
        url.API_UPDATE_NOTE +
        `/${noteIdForUpdate}` +
        ``;

      const response = await putData(requestUrl, noteData);

      if (response.status) {
        setMessageType("success");
        resetHandler();
        getAllNotes();
      } else {
        setMessageType("error");
      }

      setIsLoading(false);
      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for delete note
  const deleteNoteHandler = async (noteId) => {
    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_DELETE_NOTE +
        `/${noteId}` +
        ``;

      if (leadId) {
        requestUrl += `&leadid=${leadId}`;
      }

      if (contactId) {
        requestUrl += `&contactid=${contactId}`;
      }

      if (invoiceId) {
        requestUrl += `&invoiceid=${invoiceId}`;
      }

      if (invoiceDocId) {
        requestUrl += `&invoicedocid=${invoiceDocId}`;
      }

      if (taskId) {
        requestUrl += `&taskid=${taskId}`;
      }

      const response = await deleteData(requestUrl);

      if (response.status) {
        setMessageType("success");
        getAllNotes();
      } else {
        setMessageType("error");
      }

      setAlertMessage(response.message);
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  // Toggle accordion expand/collapse per note
  const toggleNoteExpansion = (noteId) => {
    setExpandedNotes((prev) => ({ ...prev, [noteId]: !prev[noteId] }));
  };

  // Toggle transcript visibility per note
  const toggleTranscript = (noteId) => {
    setShowTranscript((prev) => ({ ...prev, [noteId]: !prev[noteId] }));
  };

  // Initialize speech recognition (re-initializes when voiceLanguage changes)
  useEffect(() => {
    if (typeof window !== "undefined") {
      const SpeechRecognition =
        window.SpeechRecognition || window.webkitSpeechRecognition;
      if (SpeechRecognition) {
        const recognitionInstance = new SpeechRecognition();
        recognitionInstance.continuous = true;
        recognitionInstance.interimResults = true;
        recognitionInstance.lang = voiceLanguage;

        recognitionInstance.onresult = (event) => {
          let finalTranscript = "";
          for (let i = event.resultIndex; i < event.results.length; i++) {
            if (event.results[i].isFinal) {
              finalTranscript += event.results[i][0].transcript + " ";
            }
          }
          if (finalTranscript) {
            setTranscribedText((prev) => prev + finalTranscript);
          }
        };

        recognitionInstance.onerror = (event) => {
          console.error("Speech recognition error:", event.error);
          if (event.error === "no-speech") {
            setAlertMessage(t("No speech detected. Please try again."));
            setMessageType("warning");
            setShowAlert(true);
          }
        };

        recognitionInstance.onend = () => {
          if (isRecording && !isPaused) {
            recognitionInstance.start();
          }
        };

        setRecognition(recognitionInstance);
      }
    }
  }, [voiceLanguage]);

  // Speech recording handlers
  const startRecording = () => {
    if (recognition) {
      try {
        recognition.start();
        setIsRecording(true);
        setIsPaused(false);
      } catch (error) {
        console.error("Error starting recognition:", error);
      }
    } else {
      setAlertMessage(
        t("Speech recognition is not supported in your browser.")
      );
      setMessageType("error");
      setShowAlert(true);
    }
  };

  const pauseRecording = () => {
    if (recognition && isRecording) {
      recognition.stop();
      setIsPaused(true);
    }
  };

  const resumeRecording = () => {
    if (recognition && isPaused) {
      recognition.start();
      setIsPaused(false);
    }
  };

  const stopRecording = () => {
    if (recognition) {
      recognition.stop();
      setIsRecording(false);
      setIsPaused(false);
    }
  };

  const clearTranscription = () => setTranscribedText("");

  const closeVoiceOffcanvas = () => {
    stopRecording();
    setShowVoiceOffcanvas(false);
  };

  // Use transcribed text as note content
  const useTranscriptionAsNote = () => {
    if (!transcribedText.trim()) {
      setAlertMessage(t("Please record some text first."));
      setMessageType("warning");
      setShowAlert(true);
      return;
    }
    setNoteTitle("Voice Note - " + new Date().toLocaleDateString());
    setNoteDetails(transcribedText);
    setShowVoiceOffcanvas(false);
    setIsFormVisible(true);
    setTranscribedText("");
    stopRecording();
  };

  useEffect(() => {
    if (leadId || contactId || invoiceId || taskId || invoiceDocId) {
      getAllNotes();
    }
  }, [leadId, contactId, invoiceId, taskId, invoiceDocId]);

  // Set form visibility on initial notes load
  useEffect(() => {
    if (!hasCheckedInitial && !isFetchingNotes) {
      setIsFormVisible(noteList.length === 0);
      setHasCheckedInitial(true);
    }
  }, [noteList, hasCheckedInitial, isFetchingNotes]);

  return (
    <div className="bg-white border border-gray-300 rounded-15 shadow-lg overflow-hidden">
      {/* Header Section */}
      <div
        className="px-2 py-2 border-bottom border-gray-300"
        style={{
          background:
            "linear-gradient(135deg, rgba(238, 82, 60, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
        }}
      >
        <div className="d-flex align-items-center gap-2">
          <div
            className="p-1 bg-primary rounded-circle d-flex align-items-center justify-content-center"
            style={{ width: "32px", height: "32px" }}
          >
            <span className="material-symbols-outlined text-white fs-sm">
              note_add
            </span>
          </div>
          <div>
            <h6 className="fw-bold mb-0 text-dark">{`${t(
              "Notes"
            )} ${moduleName}`}</h6>
            <p className="fs-xs text-muted mb-0">
              {t("Add and manage notes for this item")}
            </p>
          </div>
        </div>
      </div>

      {isFetchingNotes ? (
        <div className="d-flex justify-content-center align-items-center py-3">
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">{t("Loading...")}</span>
          </div>
          <span className="ms-2">{t("Loading notes...")}</span>
        </div>
      ) : (
        <>
          {/* Toggle Button + Voice Note Button (only when notes exist) */}
          {noteList.length > 0 && (
            <div className="px-2 py-2 border-bottom border-gray-300">
              <div className="d-flex gap-2">
                <button
                  className="btn btn-primary rounded-10 px-2 py-2 fw-bold d-flex align-items-center gap-2 flex-grow-1 justify-content-center"
                  onClick={() => setIsFormVisible(!isFormVisible)}
                  style={{ transition: "all 0.3s ease-in-out" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.02)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(238, 82, 60, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <span className="material-symbols-outlined fs-sm">
                    {isFormVisible ? "expand_less" : "expand_more"}
                  </span>
                  <span>
                    {isFormVisible
                      ? t("Hide Add Note")
                      : t("Show Add Note")}
                  </span>
                </button>

                <button
                  className="btn btn-success rounded-10 px-2 py-2 fw-bold d-flex align-items-center gap-2"
                  onClick={() => setShowVoiceOffcanvas(true)}
                  style={{ transition: "all 0.3s ease-in-out" }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.05)";
                    e.currentTarget.style.boxShadow =
                      "0 4px 15px rgba(49, 166, 30, 0.3)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <span className="material-symbols-outlined fs-md">mic</span>
                  <span className="d-none d-md-inline">{t("Voice Note")}</span>
                </button>
              </div>
            </div>
          )}

          {/* Add Note Form (always visible when no notes, toggleable when notes exist) */}
          {(noteList.length === 0 || isFormVisible) && (
            <div className="p-2">
              {/* Voice Note button for empty state */}
              {noteList.length === 0 && (
                <div className="mb-2">
                  <button
                    className="btn btn-success rounded-10 px-3 py-1 fw-bold d-flex align-items-center gap-2 w-100 justify-content-center"
                    onClick={() => setShowVoiceOffcanvas(true)}
                    style={{ transition: "all 0.3s ease-in-out" }}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = "scale(1.02)";
                      e.currentTarget.style.boxShadow =
                        "0 4px 15px rgba(49, 166, 30, 0.3)";
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = "scale(1)";
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  >
                    <span className="material-symbols-outlined fs-md">mic</span>
                    <span>{t("Create Voice Note")}</span>
                  </button>
                  <p className="text-center text-muted mt-2 mb-0 small">
                    {t("Or use the form below to create a note manually")}
                  </p>
                </div>
              )}

              <div className="bg-light border border-gray-300 rounded-15 p-2 mb-2">
                <div className="mb-2">
                  <label className="form-label fw-semibold text-dark mb-2 d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined fs-sm text-primary">
                      title
                    </span>
                    {t("Note Title")} <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control shadow-none rounded-10 ${
                      validation.titleWarning
                        ? "is-invalid"
                        : "border border-gray-300"
                    }`}
                    style={{
                      padding: "6px 10px",
                      fontSize: "0.9rem",
                      transition: "all 0.3s ease-in-out",
                    }}
                    placeholder={t("Enter note title...")}
                    value={noteTitle}
                    onChange={(e) => {
                      setNoteTitle(e.target.value);
                      setValidation((prevState) => ({
                        ...prevState,
                        titleWarning: false,
                      }));
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = "var(--bs-primary)";
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(238, 82, 60, 0.25)";
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  />
                  {validation.titleWarning && (
                    <div className="mt-2">
                      <div
                        className="alert alert-danger border-0 rounded-10 py-2 px-3 d-flex align-items-center gap-2"
                        style={{ fontSize: "0.85rem" }}
                      >
                        <span className="material-symbols-outlined fs-sm">
                          warning
                        </span>
                        <span>{t("Please enter a title!")}</span>
                      </div>
                    </div>
                  )}
                </div>

                <div className="mb-2">
                  <label className="form-label fw-semibold text-dark mb-1 d-flex align-items-center gap-2">
                    <span className="material-symbols-outlined fs-sm text-primary">
                      description
                    </span>
                    {t("Note Details")}
                  </label>
                  <textarea
                    cols="30"
                    rows="3"
                    className="form-control border border-gray-300 shadow-none rounded-10"
                    style={{
                      padding: "6px 10px",
                      fontSize: "0.9rem",
                      resize: "vertical",
                      minHeight: "70px",
                      transition: "all 0.3s ease-in-out",
                    }}
                    placeholder={t("Enter note details (optional)...")}
                    value={noteDetails}
                    onChange={(e) => {
                      setNoteDetails(e.target.value);
                    }}
                    onFocus={(e) => {
                      e.currentTarget.style.borderColor = "var(--bs-success)";
                      e.currentTarget.style.boxShadow =
                        "0 0 0 0.2rem rgba(49, 166, 30, 0.25)";
                    }}
                    onBlur={(e) => {
                      e.currentTarget.style.boxShadow = "none";
                    }}
                  ></textarea>
                </div>

                {/* Checkboxes Section */}
                <div className="d-flex gap-2 flex-wrap">
                  <div className="flex-grow-1">
                    <div className="form-check p-2 bg-white rounded-10 border border-gray-300 h-100">
                      
                      <label
                        className="form-check-label fw-semibold text-dark ms-2"
                        htmlFor="privateCheck"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <input
                            className="form-check-input ms-0 border border-primary"
                            type="checkbox"
                            id="privateCheck"
                            checked={isPrivate}
                            onChange={(e) => setIsPrivate(e.target.checked)}
                            style={{
                              width: "18px",
                              height: "18px",
                              marginTop: "2px",
                            }}
                          />

                          <span className="material-symbols-outlined fs-sm text-primary">
                            lock
                          </span>
                          {t("Mark as Private")}
                        </div>
                        <small className="text-muted d-block mt-1">
                          {t("Only you can see this note")}
                        </small>
                      </label>
                    </div>
                  </div>

                  <div className={`flex-grow-1 ${noteIdForUpdate ? "d-none" : ""}`}>
                    <div className="form-check p-2 bg-white rounded-10 border border-gray-300 h-100">
                      
                      <label
                        className="form-check-label fw-semibold text-dark ms-2"
                        htmlFor="notificationCheck"
                      >
                        <div className="d-flex align-items-center gap-2">
                          <input
                            className="form-check-input ms-0 border border-primary"
                            type="checkbox"
                            id="notificationCheck"
                            checked={isSendNotification}
                            onChange={(e) => setIsSendNotification(e.target.checked)}
                            style={{
                              width: "18px",
                              height: "18px",
                              marginTop: "2px",
                            }}
                          />

                          <span className="material-symbols-outlined fs-sm text-primary">
                            notifications
                          </span>
                          {t("Send Notification")}
                        </div>
                        <small className="text-muted d-block mt-1">
                          {t("Notify relevant users")}
                        </small>
                      </label>
                    </div>
                  </div>
                </div>

                {/* Action Buttons */}
                <div className="mt-2">
                  <div className="d-flex align-items-center gap-2 justify-content-md-end">
                    <button
                      className={`btn btn-outline-secondary rounded-10 px-3 py-2 fw-semibold ${
                        noteIdForUpdate ? "" : "d-none"
                      }`}
                      style={{
                        cursor: isLoading ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease-in-out",
                      }}
                      disabled={isLoading}
                      onClick={resetHandler}
                      onMouseEnter={(e) => {
                        if (!isLoading) {
                          e.currentTarget.style.backgroundColor =
                            "var(--bs-secondary)";
                          e.currentTarget.style.color = "white";
                          e.currentTarget.style.transform = "scale(1.05)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isLoading) {
                          e.currentTarget.style.backgroundColor = "transparent";
                          e.currentTarget.style.color = "var(--bs-secondary)";
                          e.currentTarget.style.transform = "scale(1)";
                        }
                      }}
                    >
                      <span className="material-symbols-outlined fs-sm me-1">
                        refresh
                      </span>
                      {t("Reset")}
                    </button>

                    <button
                      className="btn btn-primary rounded-10 px-4 py-2 fw-bold d-flex align-items-center gap-2"
                      style={{
                        cursor: isLoading ? "not-allowed" : "pointer",
                        transition: "all 0.3s ease-in-out",
                      }}
                      disabled={isLoading}
                      onClick={noteIdForUpdate ? updateNoteHandler : saveNoteHandler}
                      onMouseEnter={(e) => {
                        if (!isLoading) {
                          e.currentTarget.style.transform = "scale(1.05)";
                          e.currentTarget.style.boxShadow =
                            "0 8px 25px rgba(238, 82, 60, 0.3)";
                        }
                      }}
                      onMouseLeave={(e) => {
                        if (!isLoading) {
                          e.currentTarget.style.transform = "scale(1)";
                          e.currentTarget.style.boxShadow = "none";
                        }
                      }}
                    >
                      {isLoading ? (
                        <>
                          <div
                            className="spinner-border spinner-border-sm"
                            role="status"
                          >
                            <span className="visually-hidden">Loading...</span>
                          </div>
                          <span>{t("Processing...")}</span>
                        </>
                      ) : (
                        <>
                          <span className="material-symbols-outlined fs-sm">
                            {noteIdForUpdate ? "edit" : "save"}
                          </span>
                          <span>
                            {noteIdForUpdate ? t("Update Note") : t("Save Note")}
                          </span>
                        </>
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {/* Notes List Section */}
          <div className="px-2 pb-2">
            {noteList.length > 0 ? (
              <div className="mt-2">
                <div className="d-flex align-items-center gap-2 mb-2">
                  <span className="material-symbols-outlined fs-sm text-primary">
                    format_list_bulleted
                  </span>
                  <h6 className="fw-bold mb-0 text-dark">{t("Recent Notes")}</h6>
                </div>

                {/* Accordion Notes List */}
                <div className="notes-accordion">
                  {noteList.map((note, index) => {
                    const noteId = note._id || `note-${index}`;
                    const isExpanded = expandedNotes[noteId];

                    const canEdit =
                      userInfo.role.slug === "ADMIN" ||
                      userInfo.role.slug === "SUPER_ADMIN" ||
                      note.moderator?.toString() === userInfo._id?.toString();

                    return (
                      <div
                        key={noteId}
                        className="bg-white border border-gray-200 rounded-15 mb-2 shadow-sm overflow-hidden"
                        style={{ transition: "all 0.3s ease-in-out" }}
                      >
                        {/* Clickable Note Header */}
                        <div
                          className="p-2 d-flex align-items-center justify-content-between"
                          onClick={() => toggleNoteExpansion(noteId)}
                          style={{
                            backgroundColor: isExpanded
                              ? "rgba(13, 110, 253, 0.05)"
                              : "transparent",
                            borderBottom: isExpanded
                              ? "1px solid rgba(13, 110, 253, 0.1)"
                              : "none",
                            cursor: "pointer",
                            transition: "all 0.3s ease-in-out",
                          }}
                          onMouseEnter={(e) => {
                            if (!isExpanded) {
                              e.currentTarget.style.backgroundColor =
                                "rgba(13, 110, 253, 0.02)";
                            }
                          }}
                          onMouseLeave={(e) => {
                            if (!isExpanded) {
                              e.currentTarget.style.backgroundColor =
                                "transparent";
                            }
                          }}
                        >
                          <div className="d-flex align-items-center gap-2 flex-grow-1 overflow-hidden">
                            <div
                              className="p-1 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center flex-shrink-0"
                              style={{ width: "24px", height: "24px" }}
                            >
                              <span
                                className="material-symbols-outlined"
                                style={{ fontSize: "0.75rem" }}
                              >
                                {note.isprivate ? "lock" : "note"}
                              </span>
                            </div>
                            <div className="overflow-hidden">
                              <small
                                className="text-dark fw-bold d-block text-truncate"
                                style={{ fontSize: "0.85rem" }}
                              >
                                {note.title}
                              </small>
                              <small className="text-muted" style={{ fontSize: "0.75rem" }}>
                                {note.notedate}
                                {note.callaudiourl && (
                                  <span className="ms-2 text-success fw-semibold">
                                    <span
                                      className="material-symbols-outlined"
                                      style={{ fontSize: "12px", verticalAlign: "middle" }}
                                    >
                                      mic
                                    </span>{" "}
                                    {t("Voice")}
                                  </span>
                                )}
                              </small>
                            </div>
                            {note.isprivate && (
                              <span className="badge bg-warning-subtle text-warning fs-xs px-2 py-1 rounded-pill flex-shrink-0">
                                {t("Private")}
                              </span>
                            )}
                          </div>

                          <span
                            className="material-symbols-outlined text-primary flex-shrink-0"
                            style={{
                              fontSize: "1.1rem",
                              transform: isExpanded
                                ? "rotate(180deg)"
                                : "rotate(0deg)",
                              transition: "transform 0.3s ease-in-out",
                            }}
                          >
                            expand_more
                          </span>
                        </div>

                        {/* Expandable Note Content */}
                        <div
                          style={{
                            maxHeight: isExpanded ? "none" : "0px",
                            opacity: isExpanded ? 1 : 0,
                            overflow: isExpanded ? "visible" : "hidden",
                            transition: "opacity 0.3s ease-in-out",
                          }}
                        >
                          <div className="p-2 position-relative">
                            {/* Edit / Delete actions */}
                            {canEdit && (
                              <div
                                className="d-flex gap-2 position-absolute"
                                style={{ top: 8, right: 8, zIndex: 2 }}
                              >
                                <button
                                  className="btn btn-light border-0 p-0 d-flex align-items-center justify-content-center"
                                  style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                                    transition: "background 0.2s",
                                  }}
                                  title={t("Edit")}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    updateNoteStatus(note);
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#e7f1ff";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#fff";
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined text-primary"
                                    style={{ fontSize: "1.1rem" }}
                                  >
                                    edit
                                  </span>
                                </button>
                                <button
                                  className="btn btn-light border-0 p-0 d-flex align-items-center justify-content-center"
                                  style={{
                                    width: 30,
                                    height: 30,
                                    borderRadius: "50%",
                                    boxShadow: "0 1px 4px rgba(0,0,0,0.07)",
                                    transition: "background 0.2s",
                                  }}
                                  title={t("Delete")}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    deleteNoteHandler(note._id);
                                  }}
                                  onMouseEnter={(e) => {
                                    e.currentTarget.style.background = "#fff0f0";
                                  }}
                                  onMouseLeave={(e) => {
                                    e.currentTarget.style.background = "#fff";
                                  }}
                                >
                                  <span
                                    className="material-symbols-outlined text-danger"
                                    style={{ fontSize: "1.1rem" }}
                                  >
                                    delete
                                  </span>
                                </button>
                              </div>
                            )}

                            {/* Note date */}
                            <div className="d-flex align-items-center gap-2 mb-2">
                              <span className="material-symbols-outlined fs-sm text-muted">
                                schedule
                              </span>
                              <small className="text-muted fw-semibold">
                                {note.notedate}
                              </small>
                              {note.callduration && (
                                <>
                                  <span className="text-muted">·</span>
                                  <small className="text-muted fw-semibold d-flex align-items-center gap-1">
                                    <span
                                      className="material-symbols-outlined"
                                      style={{ fontSize: "13px" }}
                                    >
                                      timer
                                    </span>
                                    {formatDuration(note.callduration)}
                                  </small>
                                </>
                              )}
                            </div>

                            {/* Note details */}
                            {note.details && (
                              <p
                                className="text-dark mb-2 lh-base"
                                style={{ fontSize: "0.95rem" }}
                              >
                                {note.details}
                              </p>
                            )}

                            {/* Audio player — supports mp3, wav, ogg, webm, m4a */}
                            {note.callaudiourl && (
                              <div className="mt-1 mb-1 p-2 bg-light rounded-10 border">
                                <div className="d-flex align-items-center justify-content-between gap-2 mb-2">
                                  <div className="d-flex align-items-center gap-2">
                                    <span className="material-symbols-outlined fs-sm text-success">
                                      headset_mic
                                    </span>
                                    <small className="fw-semibold text-success">
                                      {t("Audio Note")}
                                    </small>
                                  </div>
                                  {note.callduration && (
                                    <small className="text-muted fw-semibold">
                                      {formatDuration(note.callduration)}
                                    </small>
                                  )}
                                </div>

                                <audio
                                  controls
                                  className="w-100"
                                  style={{ height: "40px", borderRadius: "8px" }}
                                  preload="none"
                                >
                                  {/* Provide multiple sources so browser picks a supported format */}
                                  <source src={note.callaudiourl} type="audio/mpeg" />
                                  <source src={note.callaudiourl} type="audio/wav" />
                                  <source src={note.callaudiourl} type="audio/ogg" />
                                  <source src={note.callaudiourl} type="audio/webm" />
                                  <source src={note.callaudiourl} type="audio/mp4" />
                                  <p className="text-muted small mb-0">
                                    {t(
                                      "Your browser does not support audio playback."
                                    )}{" "}
                                    <a
                                      href={note.callaudiourl}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                    >
                                      {t("Download audio")}
                                    </a>
                                  </p>
                                </audio>

                                {(note.callstarttime || note.callendtime) && (
                                  <div className="d-flex justify-content-between align-items-center text-muted mt-1">
                                    {note.callstarttime && (
                                      <small className="d-flex align-items-center gap-1">
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ fontSize: "13px" }}
                                        >
                                          play_circle
                                        </span>
                                        {formatTimestamp(note.callstarttime)}
                                      </small>
                                    )}
                                    {note.callendtime && (
                                      <small className="d-flex align-items-center gap-1">
                                        <span
                                          className="material-symbols-outlined"
                                          style={{ fontSize: "13px" }}
                                        >
                                          stop_circle
                                        </span>
                                        {formatTimestamp(note.callendtime)}
                                      </small>
                                    )}
                                  </div>
                                )}

                                {/* Transcript toggle */}
                                {note.calltranscript && (
                                  <div className="mt-2">
                                    <a
                                      href="#"
                                      className="d-flex align-items-center gap-1 text-decoration-none text-primary fw-semibold"
                                      style={{ fontSize: "0.85rem" }}
                                      onClick={(e) => {
                                        e.preventDefault();
                                        toggleTranscript(noteId);
                                      }}
                                    >
                                      <span
                                        className="material-symbols-outlined"
                                        style={{ fontSize: "16px" }}
                                      >
                                        {showTranscript[noteId]
                                          ? "expand_less"
                                          : "expand_more"}
                                      </span>
                                      {showTranscript[noteId]
                                        ? t("Hide Transcript")
                                        : t("View Transcript")}
                                    </a>

                                    {showTranscript[noteId] && (
                                      <div className="mt-1 p-2 bg-white rounded-8 border border-gray-300">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                          <span
                                            className="material-symbols-outlined text-primary"
                                            style={{ fontSize: "16px" }}
                                          >
                                            subtitles
                                          </span>
                                          <strong className="text-dark" style={{ fontSize: "0.85rem" }}>
                                            {t("Transcript")}
                                          </strong>
                                        </div>
                                        <div
                                          className="text-muted"
                                          style={{
                                            fontSize: "0.875rem",
                                            lineHeight: "1.6",
                                            maxHeight: "250px",
                                            overflowY: "auto",
                                            whiteSpace: "pre-line",
                                          }}
                                        >
                                          {note.calltranscript}
                                        </div>
                                      </div>
                                    )}
                                  </div>
                                )}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>

                <div className="text-center mt-2">
                  <small className="text-muted d-flex align-items-center justify-content-center gap-1">
                    <span className="material-symbols-outlined fs-sm">info</span>
                    {t("Click to expand / collapse")}
                  </small>
                </div>
              </div>
            ) : (
              <div className="text-center py-3">
                <div
                  className="p-3 bg-light rounded-circle d-inline-flex align-items-center justify-content-center mb-2"
                  style={{ width: "60px", height: "60px" }}
                >
                  <span
                    className="material-symbols-outlined text-muted"
                    style={{ fontSize: "2rem" }}
                  >
                    note_add
                  </span>
                </div>
                <h6 className="fw-bold text-muted mb-2">{t("No Notes Yet")}</h6>
                <p className="text-muted mb-0">
                  {t("Add your first note using the form above")}
                </p>
              </div>
            )}
          </div>
        </>
      )}

      {/* Voice Recording Offcanvas */}
      <div
        className={`offcanvas offcanvas-end ${showVoiceOffcanvas ? "show" : ""}`}
        tabIndex="-1"
        style={{
          visibility: showVoiceOffcanvas ? "visible" : "hidden",
          width: "500px",
          maxWidth: "90vw",
        }}
      >
        <div
          className="offcanvas-header border-bottom"
          style={{
            background:
              "linear-gradient(135deg, rgba(49, 166, 30, 0.1) 0%, rgba(255, 255, 255, 0.95) 100%)",
          }}
        >
          <div className="d-flex align-items-center gap-3">
            <div
              className="p-2 bg-success rounded-circle d-flex align-items-center justify-content-center"
              style={{ width: "40px", height: "40px" }}
            >
              <span className="material-symbols-outlined text-white fs-md">mic</span>
            </div>
            <div>
              <h5 className="offcanvas-title fw-bold mb-0">
                {t("Voice Note")}
              </h5>
              <small className="text-muted">
                {t("Record speech and generate a note")}
              </small>
            </div>
          </div>
          <div className="d-flex align-items-center gap-2">
            <div
              className="btn-group btn-group-sm"
              role="group"
              aria-label="Voice language"
            >
              <button
                type="button"
                className={`btn ${voiceLanguage === "en-US" ? "btn-success" : "btn-outline-success"}`}
                onClick={() => setVoiceLanguage("en-US")}
                disabled={isRecording}
                title="English"
              >
                EN
              </button>
              <button
                type="button"
                className={`btn ${voiceLanguage === "es-ES" ? "btn-success" : "btn-outline-success"}`}
                onClick={() => setVoiceLanguage("es-ES")}
                disabled={isRecording}
                title="Spanish"
              >
                ES
              </button>
            </div>
            <button
              type="button"
              className="btn-close"
              onClick={closeVoiceOffcanvas}
            ></button>
          </div>
        </div>

        <div className="offcanvas-body p-3">
          {/* Recording Status */}
          <div className="mb-3">
            <div
              className={`alert d-flex align-items-center gap-3 border-0 ${
                isRecording && !isPaused
                  ? "alert-success"
                  : isPaused
                  ? "alert-warning"
                  : "alert-secondary"
              }`}
              style={{ borderRadius: "10px", padding: "10px" }}
            >
              <div className="position-relative">
                {isRecording && !isPaused && (
                  <span
                    className="position-absolute top-0 start-0 w-100 h-100 rounded-circle"
                    style={{
                      animation: "voicePulse 1.5s ease-in-out infinite",
                      backgroundColor: "rgba(49, 166, 30, 0.3)",
                    }}
                  ></span>
                )}
                <span
                  className={`material-symbols-outlined fs-2 ${
                    isRecording && !isPaused
                      ? "text-success"
                      : isPaused
                      ? "text-warning"
                      : "text-secondary"
                  }`}
                >
                  {isRecording && !isPaused
                    ? "radio_button_checked"
                    : isPaused
                    ? "pause_circle"
                    : "mic_off"}
                </span>
              </div>
              <div className="flex-grow-1">
                <div className="fw-bold">
                  {isRecording && !isPaused
                    ? t("Recording...")
                    : isPaused
                    ? t("Paused")
                    : t("Not Recording")}
                </div>
                <small className="text-muted">
                  {isRecording && !isPaused
                    ? t("Speak clearly into your microphone")
                    : isPaused
                    ? t("Recording is paused")
                    : t("Click the microphone button to start")}
                </small>
              </div>
            </div>
          </div>

          {/* Recording Controls */}
          <div className="mb-3">
            <div className="d-flex justify-content-center gap-3">
              {!isRecording ? (
                <button
                  className="btn btn-success btn-lg rounded-circle d-flex align-items-center justify-content-center"
                  onClick={startRecording}
                  style={{
                    width: "80px",
                    height: "80px",
                    transition: "all 0.3s ease-in-out",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.1)";
                    e.currentTarget.style.boxShadow =
                      "0 8px 25px rgba(49, 166, 30, 0.4)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                    e.currentTarget.style.boxShadow = "none";
                  }}
                >
                  <span
                    className="material-symbols-outlined"
                    style={{ fontSize: "2.5rem" }}
                  >
                    mic
                  </span>
                </button>
              ) : (
                <>
                  {isPaused ? (
                    <button
                      className="btn btn-warning btn-lg rounded-circle d-flex align-items-center justify-content-center"
                      onClick={resumeRecording}
                      style={{ width: "70px", height: "70px" }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: "2rem" }}
                      >
                        play_arrow
                      </span>
                    </button>
                  ) : (
                    <button
                      className="btn btn-warning btn-lg rounded-circle d-flex align-items-center justify-content-center"
                      onClick={pauseRecording}
                      style={{ width: "70px", height: "70px" }}
                    >
                      <span
                        className="material-symbols-outlined"
                        style={{ fontSize: "2rem" }}
                      >
                        pause
                      </span>
                    </button>
                  )}
                  <button
                    className="btn btn-danger btn-lg rounded-circle d-flex align-items-center justify-content-center"
                    onClick={stopRecording}
                    style={{ width: "70px", height: "70px" }}
                  >
                    <span
                      className="material-symbols-outlined"
                      style={{ fontSize: "2rem" }}
                    >
                      stop
                    </span>
                  </button>
                </>
              )}
            </div>
            <div className="text-center mt-3">
              <small className="text-muted fw-semibold">
                {isRecording && !isPaused
                  ? t("Click pause to temporarily stop or stop to finish")
                  : isPaused
                  ? t("Click play to resume or stop to finish")
                  : t("Click the microphone to start recording")}
              </small>
            </div>
          </div>

          {/* Transcribed Text */}
          <div className="mb-3">
            <label className="form-label fw-bold d-flex align-items-center gap-2 mb-2">
              <span className="material-symbols-outlined fs-sm text-primary">
                description
              </span>
              {t("Transcribed Text")}
            </label>
            <textarea
              className="form-control border border-gray-300 shadow-none rounded-10"
              rows="8"
              value={transcribedText}
              onChange={(e) => setTranscribedText(e.target.value)}
              placeholder={t("Your speech will appear here as text...")}
              style={{ fontSize: "0.95rem", lineHeight: "1.6", resize: "vertical" }}
            ></textarea>
            {transcribedText && (
              <button
                className="btn btn-outline-secondary btn-sm mt-2 rounded-10"
                onClick={clearTranscription}
              >
                <span className="material-symbols-outlined fs-sm me-1">delete</span>
                {t("Clear")}
              </button>
            )}
          </div>

          {/* Use Transcription Button */}
          <div>
            <button
              className="btn btn-primary w-100 rounded-10 py-3 fw-bold d-flex align-items-center justify-content-center gap-2"
              onClick={useTranscriptionAsNote}
              disabled={!transcribedText.trim()}
              style={{ transition: "all 0.3s ease-in-out" }}
              onMouseEnter={(e) => {
                if (transcribedText.trim()) {
                  e.currentTarget.style.transform = "scale(1.02)";
                  e.currentTarget.style.boxShadow =
                    "0 8px 25px rgba(238, 82, 60, 0.3)";
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "scale(1)";
                e.currentTarget.style.boxShadow = "none";
              }}
            >
              <span className="material-symbols-outlined fs-md">
                note_add
              </span>
              <span>{t("Use as Note")}</span>
            </button>
            <p className="text-center text-muted mt-2 mb-0 small">
              {t("Transcription will be added to the note form for review and saving")}
            </p>
          </div>
        </div>
      </div>

      {/* Offcanvas Backdrop */}
      {showVoiceOffcanvas && (
        <div
          className="offcanvas-backdrop fade show"
          onClick={closeVoiceOffcanvas}
        ></div>
      )}

      {/* Pulse animation for recording indicator */}
      <style>{`
        @keyframes voicePulse {
          0%, 100% { transform: scale(1); opacity: 1; }
          50% { transform: scale(1.3); opacity: 0.5; }
        }
      `}</style>
    </div>
  );
};

export default NoteSection;
